import { useAuthRouteDataContext } from 'providers/AuthRouteDataProvider/AuthRouteDataProvider.context';
import { FC } from 'react';
import { Redirect } from 'react-router-dom';

export const LocationSettingsPageRedirect: FC = () => {
  const { locationFilter } = useAuthRouteDataContext();

  return <Redirect to={`/settings/locations/${locationFilter.initialValue.value}/general`} />;
};
